import script from "./ModalComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModalComponent.vue?vue&type=script&lang=ts&setup=true"

import "./ModalComponent.vue?vue&type=style&index=0&id=539709de&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-539709de"]])

export default __exports__